import type { CSSProperties } from 'react';

import { APP_BOTTOM_CLEARANCE_CSS_VAR } from 'cpool-components/general/Modal/utils';

import { VITE_MODE } from '~/config';

export const STAGING_FOOTER_BAR_HEIGHT_PX = 32;

export const STAGING_FOOTER_CLEARANCE = `calc(${STAGING_FOOTER_BAR_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px))`;

export function getStagingOutletPaddingBottomStyle(): CSSProperties {
    if (VITE_MODE !== 'staging') {
        return {};
    }
    return {
        paddingBottom: STAGING_FOOTER_CLEARANCE,
    };
}

export function getAppShellMinHeightStyle(): CSSProperties {
    if (VITE_MODE !== 'staging') {
        return {};
    }
    return {
        minHeight: `calc(100vh - ${STAGING_FOOTER_CLEARANCE})`,
    };
}

/** Exposes staging footer height so fixed UI (e.g. sidebar modals) can clear it. */
export function setStagingFooterClearanceCssVar(enabled: boolean): void {
    const rootStyle = document.documentElement.style;
    if (enabled) {
        rootStyle.setProperty(APP_BOTTOM_CLEARANCE_CSS_VAR, STAGING_FOOTER_CLEARANCE);
        return;
    }
    rootStyle.removeProperty(APP_BOTTOM_CLEARANCE_CSS_VAR);
}
